import { render } from "./ReportProductSales.vue?vue&type=template&id=136cd14e&scoped=true"
import script from "./ReportProductSales.vue?vue&type=script&lang=js"
export * from "./ReportProductSales.vue?vue&type=script&lang=js"

import "./ReportProductSales.vue?vue&type=style&index=0&id=136cd14e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136cd14e"]])

export default __exports__